var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-audio-recorder",class:{
      'active': _vm.isRecording2
    },on:{"click":_vm.toggleRecorder}},[(!_vm.isRecording2)?_c('span'):_c('i',{class:{
    'ni ni-button-pause': _vm.isRecording2},staticStyle:{"font-size":"1.5rem","color":"#fff","padding":"1.1rem"}})])}
var staticRenderFns = []

export { render, staticRenderFns }